import type { SVGProps } from "react";
// generated from MailPlus.svg — do not edit manually
// prettier-ignore
export default function MailPlus(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M18.995 13V16.995M18.995 16.995V21M18.995 16.995H23M18.995 16.995H15M2 7V20H14M2 7V4H22V7M2 7L12 14L22 7M22 7V12" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
